import React from 'react';
import PropTypes from 'prop-types';
import { Modal, ModalBody } from 'reactstrap';
import { Player, ControlBar, BigPlayButton } from 'video-react';
import { TbX } from 'react-icons/tb';

function VideoPreviewModal({ isOpen, toggleModal, video }) {
  return (
    video && (
      <Modal
        size="full-page"
        isOpen={isOpen}
        toggle={toggleModal}
        centered={true}
        className="damage-modal video-preview-modal"
      >
        <div className="modal-header justify-content-center video-preview-modal-body">
          <button
            type="button"
            className="photo_gallery_close_button"
            data-dismiss="modal"
            aria-label="Close"
            onClick={toggleModal}
          >
            <TbX size={24} />
          </button>
        </div>
        <ModalBody>
          <div className="video-react_popup_slider">
            <Player src={video}>
              <BigPlayButton position="center" />
              <ControlBar autoHide={false} className="my-class" />
            </Player>
          </div>
        </ModalBody>
      </Modal>
    )
  );
}

VideoPreviewModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  toggleModal: PropTypes.func.isRequired,
  video: PropTypes.string,
};

VideoPreviewModal.defaultProps = {
  video: '',
};
export default VideoPreviewModal;
